import { DefaultButton, Dialog, DialogFooter, DialogType, IDialogContentProps, PrimaryButton, Spinner, SpinnerSize } from "@fluentui/react";
import React from "react";

export interface ICMConfirmModalProps {
    title: string;
    message?: string;
    htmlContent?: JSX.Element;
    showDialog: boolean;
    closeText?: string;
    confirmText: string;
    closeDialog: () => void;
    onConfirm?: () => void;
    isBusy?: boolean;
}

export const CMConfirmModal = ({ title, message, htmlContent, showDialog, closeDialog, onConfirm, closeText, confirmText, isBusy }: ICMConfirmModalProps) => {
    let dialogContentProps: IDialogContentProps = {
        type: DialogType.normal,
        title,
        subText: message,
        showCloseButton: true,
        closeButtonAriaLabel: 'Close'
    };

    if (message) {
        dialogContentProps.subText = message;
    }

    return (
        <Dialog hidden={!showDialog} onDismiss={() => closeDialog()} dialogContentProps={dialogContentProps} >
            {htmlContent}
            <DialogFooter>
                {closeText && <DefaultButton onClick={() => closeDialog()} text={closeText} disabled={isBusy} />}
                {onConfirm &&
                    <PrimaryButton
                        autoFocus
                        onClick={() => onConfirm()}
                        text={confirmText}
                        disabled={isBusy}
                    >
                        {isBusy && <Spinner size={SpinnerSize.small} />}
                    </PrimaryButton>}
            </DialogFooter>
        </Dialog>
    )
};